import { useCallback, useState } from "react";
import { BackIcon } from "./back-icon";
import ServiceLocator from "../../../../domain/service-locator";

const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, undefined, 0, undefined];

interface KeypadProps {
  onComplete: () => void;
}

export const Keypad = (props: KeypadProps) => {
  const theme = ServiceLocator.ThemeStore.theme;
  // const [_, setSearchParams] = useSearchParams();
  const guidePlayerModule = ServiceLocator.GuidePlayerModule;
  const playerLayoutModule = ServiceLocator.PlayerLayoutModule;
  const languageRepository = ServiceLocator.LanguageRepository;
  const shouldMarginBottom = guidePlayerModule.currentTrack.watch();
  const miniPlayerHeight =
    playerLayoutModule.playerRectInfo.watch().miniPlayerHeight;

  const localizedEntityRepository = ServiceLocator.LocalizedEntityRepository;
  const { application, tours, guides } =
    localizedEntityRepository.entities.watch();
  const currentLanguageId = languageRepository.currentLanguageId.watch();
  const languages = languageRepository.languages;

  const [num, setNum] = useState<string>("");

  const handleClickOkButton = useCallback(() => {
    setNum("");
    const guide = guides.find((x) => x.trackNumber === Number(num));
    if (!guide) return;

    const currentLanguage = languages.find((x) => x.id === currentLanguageId);
    if (!application || !currentLanguage) return;

    const tour = tours.find((x) => x.id === guide.tourId);
    if (!tour) return;

    window.location.hash = guide.id;

    // const shouldShowPlayer = guidePlayerModule.currentTrack.value === null;
    guidePlayerModule.select(guide.id);
    playerLayoutModule.playerType.setValue("full");
    // setSearchParams((prev) => {
    //   prev.set("guideId", guide.id);
    //   return prev;
    // });
    props.onComplete();
  }, [
    guides,
    languages,
    application,
    tours,
    guidePlayerModule,
    playerLayoutModule.playerType,
    props,
    num,
    currentLanguageId,
  ]);

  return (
    <div
      className={
        "flex-grow w-full flex flex-col justify-evenly overflow-y-scroll hidden-scrollbar"
      }
    >
      <div className="text-center text-black font-bold">
        聴きたいガイド番号を押して
        <br />
        OKボタンを押してください。
      </div>
      <div
        className="relative flex items-center justify-center h-24 w-full text-[4rem] text-center font-bold flex-shrink-0"
        style={{ color: theme.color.primary }}
      >
        {num.split("").map((x) => (
          <span className="">{x}</span>
        ))}
      </div>
      <div className="w-[80%] mx-auto">
        <div
          className="relative w-full grid grid-cols-3 gap-y-5"
          style={{ color: theme.color.primary }}
        >
          {numbers.map((x, i) =>
            x !== undefined ? (
              <div
                className="flex justify-center items-center text-[3rem] font-bold"
                key={`keypad-num-${x}`}
                onClick={() =>
                  setNum((y) => (y.length >= 3 ? y : y + x.toString()))
                }
              >
                {x && x}
              </div>
            ) : i === 11 ? (
              <div
                className="flex items-center justify-center pr-7 pt-2"
                onClick={() => {
                  setNum("");
                }}
              >
                <BackIcon color={theme.color.primary} width={45} />
              </div>
            ) : (
              <div />
            )
          )}
        </div>
      </div>
      <div
        className="cursor-pointer rounded-full w-fit py-1 px-24 mx-auto font-bold text-2xl mt-5"
        style={{ backgroundColor: theme.color.primary }}
        onClick={handleClickOkButton}
      >
        OK
      </div>
      {shouldMarginBottom && (
        <div
          className="w-full flex-shrink-0"
          style={{ height: miniPlayerHeight }}
        />
      )}
    </div>
  );
};
